export default {
  homePageCustomerClickable: true,
  homePageCustomerCopiable: true,
  newPromotion: true,
  zambiaLeader: true,
};
